export const CATEGORIES = [
  'Fixed Hard Costs',
  'Services & Safety',
  'Living Allocations',
  'Subscriptions & Caps',
  'Debt Paydown',
] as const;
export type Category = (typeof CATEGORIES)[number];

export const CATEGORY_BADGE: Record<string, string> = {
  'Fixed Hard Costs'    : 'bg-rose-100 text-rose-700 dark:bg-rose-900/40 dark:text-rose-300 ring-1 ring-rose-200/60 dark:ring-rose-800/40',
  'Services & Safety'   : 'bg-amber-100 text-amber-700 dark:bg-amber-900/40 dark:text-amber-300 ring-1 ring-amber-200/60 dark:ring-amber-800/40',
  'Living Allocations'  : 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/40 dark:text-emerald-300 ring-1 ring-emerald-200/60 dark:ring-emerald-800/40',
  'Subscriptions & Caps': 'bg-sky-100 text-sky-700 dark:bg-sky-900/40 dark:text-sky-300 ring-1 ring-sky-200/60 dark:ring-sky-800/40',
  'Debt Paydown'        : 'bg-violet-100 text-violet-700 dark:bg-violet-900/40 dark:text-violet-300 ring-1 ring-violet-200/60 dark:ring-violet-800/40',
};
export const FALLBACK_BADGE =
  'bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300 ring-1 ring-slate-200/60 dark:ring-slate-700/40';

export const zar = new Intl.NumberFormat('en-ZA', {
  style: 'currency',
  currency: 'ZAR',
  minimumFractionDigits: 2,
});
export const formatZAR = (n: number) => zar.format(Number(n) || 0);

export function monthLabel(ym: string): string {
  const [y, m] = ym.split('-').map(Number);
  return new Date(y, m - 1, 1).toLocaleDateString('en-ZA', { month: 'long', year: 'numeric' });
}

export function shiftMonth(ym: string, delta: number): string {
  const [y, m] = ym.split('-').map(Number);
  const d = new Date(y, m - 1 + delta, 1);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
}

export function formatDate(iso: string | null): string {
  if (!iso) return '';
  return new Date(iso).toLocaleDateString('en-ZA', {
    day: '2-digit', month: 'short', year: 'numeric',
  });
}

export const MASKED = 'R ••••••';
